import { render } from "./sti-dest-need-to-sti-dest-del.vue?vue&type=template&id=5c6d8e4a&scoped=true&ts=true"
import script from "./sti-dest-need-to-sti-dest-del.vue?vue&type=script&lang=ts"
export * from "./sti-dest-need-to-sti-dest-del.vue?vue&type=script&lang=ts"

import "./sti-dest-need-to-sti-dest-del.vue?vue&type=style&index=0&id=5c6d8e4a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6d8e4a"]])

export default __exports__